export const scriptParameterDefault: any = {
  type: [
    {
      label: "Web",
      value: "Web",
    },
    {
      label: "Mobile",
      value: "Mobile",
    },
  ],
  browser: [
    {
      label: "Chrome",
      value: "Chrome",
    },
    {
      label: "Firefox",
      value: "Firefox",
    },
    {
      label: "Edge",
      value: "Edge",
    },
  ],
  iftype: [
    {
      label: "cond 1",
      value: "Web",
    },
    {
      label: "cond 2",
      value: "desktop",
    },
  ],
  locator: [
    {
      label: "XPath",
      value: "XPath",
    },
    {
      label: "ID",
      value: "ID",
    },
    {
      label: "CSS Selector",
      value: "CSS Selector",
    },
    {
      label: "Class Name",
      value: "Class Name",
    },
    {
      label: "Name",
      value: "Name",
    },
    {
      label: "Tag Name",
      value: "Tag Name",
    },
    {
      label: "Link Text",
      value: "Link Text",
    },
    {
      label: "Partial Link Text",
      value: "Partial Link Text",
    },
  ],
  mobiletypes: [
    {
      label: "Native",
      value: "native",
    },
    {
      label: "Hybrid",
      value: "hybrid",
    },
    {
      label: "Mobile-Web",
      value: "mobile-web",
    },
    {
      label: "Cross-Platform",
      value: "cross-platform",
    },
  ],
  mobileplatform: [
    {
      label: "Android",
      value: "android",
    },
    {
      label: "iOS",
      value: "ios",
    },
  ],
};
